
import "../MyPoints/MyPoints.css";
import Sidebarmenu from "../../SideMenu/Sidemenu";
import SocialShare from "./social-share";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import user from "../../../../img/dum.webp";
import dollarIcon from "../../../../img/dollar-symbol.png"
import { useDispatch } from "react-redux";
import { userView, pointsHistory, getReferLink } from "../../../../Helper/Redux/API";
import { toast } from "react-toastify";
import {CopyToClipboard} from 'react-copy-to-clipboard';
function MyPoints() {
  const history = useNavigate();
  const dispatch = useDispatch();

  const [getappointment, setGetAppointment] = useState([]);
  const [referCode, setReferCode] = useState("");
  console.log(referCode)
  const [points, setPoints] = useState({
    total_points: '',
    used_points: '',
    avail_points: '',
    exp_date: '',
  });
  const getReferCode = () => {
  
    const requestOption = {
      user_id: localStorage.getItem("id"),
    };
  
    try {
      dispatch(getReferLink(requestOption)).then((res) => {
        console.log(res.payload.data);
        if (res.payload.status === true) {
          setReferCode(res.payload.data.refer_code);
        } else {
          setReferCode("");
        }
      });
    } catch (error) {
      console.log("error", error);
    }
  };
  
  useEffect(()=>{getReferCode()},[])
  const [isLoading, setIsLoading] = useState(true);

  const access_token = localStorage.getItem("access_token");
  const UserName = localStorage.getItem("UserName");
  const LastName = localStorage.getItem("lastName");
  const { pathname } = useLocation();
  const logout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("UserName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("Roleid");
    localStorage.removeItem("id");
    localStorage.removeItem("step2");
    localStorage.removeItem("step3");
    localStorage.removeItem("step4");
    localStorage.removeItem("step5");
    localStorage.removeItem("step6");
    localStorage.removeItem("step7");
    localStorage.removeItem("step8");
    localStorage.removeItem("step9");
    localStorage.removeItem("Rightear2KHz");
    localStorage.removeItem("Rightear4KHz");
    localStorage.removeItem("Leftear1KHz");
    localStorage.removeItem("Leftear6KHz");
    localStorage.removeItem("Measuretest");
    localStorage.removeItem("result_test_id");
    localStorage.removeItem("Rightear500Hz");
    localStorage.removeItem("rightear1KHz");
    localStorage.removeItem("Leftear500Hz");
    localStorage.removeItem("Leftear2000KHz");
    localStorage.removeItem("UserName");
    localStorage.removeItem("LastName");
    // localStorage.removeItem("testtrue");

    history("/");
  };

  const getAppointmentData = () => {
    setIsLoading(true);
    const userid = {
      user_id: localStorage.getItem("id"),
    };
    dispatch(pointsHistory(userid))
      .then((res) => {
        if (res?.payload?.status === true) {
          setGetAppointment(res?.payload?.data);
          setPoints({
            total_points: res?.payload?.total_points,
            used_points: res?.payload?.used_points,
            avail_points: res?.payload?.avail_points,
            exp_date: res?.payload?.expire_date,
          })
          // console.log(res?.payload?.data, "ff");
        } else {
          // toast.error(res?.payload?.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching test data:", error);
        // Handle error if needed
      })
      .finally(() => {
        setIsLoading(false); 
      });
  };

  const [intintialValue, setInitialValue] = useState({
    name: "",
    image: "",
  });

  const getviewuser = () => {
    const data = {
      id: localStorage.getItem("id"),
    };
    try {
      dispatch(userView(data)).then((res) => {
        if (res?.payload?.status === true) {
          setInitialValue({
            name: `${res?.payload?.data.first_name} ${
              res?.payload?.data.last_name ? res?.payload?.data.last_name : ""
            }`,
            image: res?.payload?.data.media[0]?.original_url,
          });
        }

        if (res?.payload?.is_active == false) {
          toast.error(res?.payload?.message);
          logout();
        }
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getviewuser();
    getAppointmentData();
  }, []);

    return (
      <>
        <div
          className="side_div_menu"
          style={{ display: "flex", height: "100%" }}
        >
          <Sidebarmenu />
          <section className="Home_page allsection">
            {" "}
            {/* <TopHeader heding_text="My Points" /> */}
            <section className="top_head sticky-top pb-3">
        <div className="container-fluid">
          <div className="top_bar_section row align-items-md-center">
            <div className="col-9">
              <div className="heaing_test align-items-start">
                <h1 className="mt-md-2 mt-1">
                  <img src={dollarIcon} width={30} height={30} alt="dollar sign" />
                </h1>
                &nbsp;&nbsp;
                
                  <div className="MyPoints">
                    <div className="MyPoints-headingbar d-flex justify-content-between">
                        <div className="MyPoints-headingbar-link">
                            <span>http://hearing.codingserver.com/Signup</span>
                            <p><SocialShare referCode={referCode}/></p>

                            <CopyToClipboard text={`http://hearing.codingserver.com/Signup/?refer=${referCode}`}
                                onCopy={() => toast.success("Copied!")}
                              >
                            <p><i className="fa fa-files-o" title="Copy"></i></p>
                          </CopyToClipboard>
                        </div>
                    </div>
                    <p className="custom-content small mt-2 mb-0">"Share this referral with your friends and get a 5% discount on your next purchase as a thank you."</p>
                </div>
            </div>
                    
                    
            </div>
            <div className="col-3">
              <div class="dropdown">
                <button
                  class="btn btn-secondary dropdown-toggle"
                  type="button"
                  id="Top_header"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div className="avatarName d-none d-md-inline-block">
                    {UserName ? UserName : ""}&nbsp;
                    {LastName ? LastName : ""} &nbsp;&nbsp;
                  </div>
                  <img
                    src={intintialValue?.image ? intintialValue?.image : user}
                    className="img-fluid profile"
                    alt="user_img"
                  />
                </button>
                <ul class="dropdown-menu" aria-labelledby="Top_header">
                  <li>
                    <a class="dropdown-item" onClick={logout}>
                      Logout
                    </a>
                  </li>
                </ul>
              </div>
         
            </div>
          </div>
        </div>
      </section>


            <div className="container-fluid p-4">
              <div className="d-md-flex align-items-center justify-content-between">
                <h3 className="pb-2">Points History</h3>
                <p className="text-md-end text-danger custom-content">{ points.total_points == "0"?"":`Your Points will be expire on ${points.exp_date}`}</p>
              </div>
              <div class="row">
                <div class="col-md-4 mb-4">
                  <div class="top-box">
                    <p>Earned Points </p>
                    <h4>{points.total_points} <span>SGD </span></h4>
                  </div>
                </div>

                <div class="col-md-4 mb-4">
                  <div class="top-box">
                    <p>Used Points</p>
                    <h4>{points.used_points} <span>SGD </span></h4>
                  </div>
                </div>

                <div class="col-md-4 mb-4">
                  <div class="top-box">
                    <p>Balance Points</p>
                    <h4>{points.avail_points} <span>SGD </span></h4>
                  </div>
                </div>
              </div>
                <div className="table-responsive pt-2 border-top">
                    <table className="table invoice_tabel">
                        <thead>
                            <tr>
                                <th scope="col"> Sr.No</th>
                                <th scope="col"> Date</th>
                                <th scope="col">Earned Points</th>
                                <th scope="col">Used Points</th>
                                <th scope="col">Source</th>
                            </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            // Render a loader while data is being fetched
                            <tr>
                              <td colSpan="5" style={{ textAlign: "center" }}>
                                Custom
                              </td>
                            </tr>
                          ) : (
                            Array.isArray(getappointment) &&
                            getappointment
                              .slice() // Create a copy of the array to avoid mutating the original
                              .sort(
                                (a, b) =>
                                  new Date(b.start_date_time) -
                                  new Date(a.start_date_time)
                              ) // Sort dates in ascending order
                              .map((item, index) => (
                                <tr key={item?.id}>
                                  <td>{index+1}</td>  
                                  <td>{item?.transaction_date}</td>
                                  <td>{item.earned_points}</td>  
                                  <td>{item.points}</td>  
                                  {/* <td>{item.earn_type == true ? `+ ${item.earned_points}`:`- ${item.points}`}</td> */}
                                  <td>{item.refer_type == 2 ? `${item.source}(${item.refree_name})`:item.source}</td>
                                </tr>
                              ))
                          )}
                        </tbody>
                        {/* <tbody>
                            <tr>
                                <td>34 USD</td>
                                <td>25 USD</td>
                                <td style={{textAlign: "center"}}>9 USD</td>
                                <td style={{textAlign: "right"}}>Self Purchase</td>
                            </tr>
                            <tr>
                                <td>34 USD</td>
                                <td>25 USD</td>
                                <td style={{textAlign: "center"}}>9 USD</td>
                                <td style={{textAlign: "right"}}>Affilate (Name)</td>
                            </tr>
                        </tbody> */}
                    </table>
                </div>   
              
              {/* <p className="mt-5 text-end text-danger">Your Points will be expire on {points.exp_date}</p> */}
            </div>
          </section>
        </div>
      </>
    );
  }

export default MyPoints;
